import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { LocaleProvider } from './contexts/LocaleContext';
import PlanPage from './pages/PlanPage';
import ResultPage from './pages/ResultPage';
import DrivePage from './pages/DrivePage';
import StopDetailPage from './pages/StopDetailPage';
import AccessoriesPage from './pages/AccessoriesPage';

import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocaleProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PlanPage />} />
          <Route path="/result/:tripId" element={<ResultPage />} />
          <Route path="/drive/:tripId" element={<DrivePage />} />
          <Route path="/stop/:stopId" element={<StopDetailPage />} />
          <Route path="/accessories" element={<AccessoriesPage />} />
        </Routes>
      </BrowserRouter>
    </LocaleProvider>
  </React.StrictMode>
);
